module.exports = (s) => {
  const form_params = {
    // 素材规格名称
    name: {
      type: 'input',
      props: {
        placeholder: '请输入规格名称',
      },
      label: '规格名称',
      value: null,
      rules: [
        { required: true, message: '请输入规格名称', trigger: ['blur', 'change'] },
      ],
    },
    // 素材类别
    type: {
      type: 'select',
      props: {
        placeholder: '请选择素材类别',
      },
      on: {
        change: (val) => {
          const img_options = [
            {
              label: 'bmp',
              value: 'bmp',
            },
            {
              label: 'jpg',
              value: 'jpg',
            },
            {
              label: 'jpeg',
              value: 'jpeg',
            },
            {
              label: 'png',
              value: 'png',
            },
            {
              label: 'gif',
              value: 'gif',
            },
          ];
          const video_options = [
            {
              label: 'mp4',
              value: 'mp4',
            },
            {
              label: 'mov',
              value: 'mov',
            },
            {
              label: 'avi',
              value: 'avi',
            },
          ];
          const obj = {
            1: img_options,
            2: video_options,
            3: img_options,
            4: img_options,
          };

          form_params.mime_type.value = [];
          form_params.mime_type.options = obj[val];

          if (val !== 2) {
            form_params.min_millisecond.hidden = true;
            form_params.max_millisecond.hidden = true;
          } else {
            form_params.min_millisecond.hidden = false;
            form_params.max_millisecond.hidden = false;
          }
        },
      },
      options: [{
        label: '图片',
        value: 1,
      },
      {
        label: '视频',
        value: 2,
      },
      {
        label: '落地页',
        value: 3,
      },
      {
        label: '组图',
        value: 4,
      }],
      label: '素材类别',
      value: null,
      rules: [
        { required: true, message: '请选择素材类别', trigger: ['blur', 'change'] },
      ],
    },
    // 素材数量
    num: {
      type: 'input',
      props: {
        placeholder: '请输入素材数量',
        type: 'number',
      },
      on: {
        change: (val) => {
          form_params.num.value = Number(val);
        },
      },
      label: '素材数量',
      value: null,
      rules: [
        { required: true, message: '请输入素材数量', trigger: ['blur', 'change'] },
      ],
    },
    // 最小尺寸
    min_size: {
      type: 'input',
      props: {
        placeholder: '请输入最小尺寸',
        type: 'number',
      },
      on: {
        change: (val) => {
          form_params.min_size.value = Number(val);
        },
      },
      label: '最小尺寸',
      value: '',
      rules: [
        { required: true, message: '请输入最小尺寸', trigger: ['blur', 'change'] },
      ],
    },
    // 最大尺寸
    max_size: {
      type: 'input',
      props: {
        placeholder: '请输入最大尺寸',
        type: 'number',
      },
      on: {
        change: (val) => {
          form_params.max_size.value = Number(val);
        },
      },
      label: '最大尺寸',
      value: null,
      rules: [
        { required: true, message: '请输入最大尺寸', trigger: ['blur', 'change'] },
      ],
    },
    // 素材宽度
    width: {
      type: 'input',
      props: {
        placeholder: '请输入素材宽度',
        type: 'number',
      },
      on: {
        change: (val) => {
          form_params.width.value = Number(val);
        },
      },
      label: '素材宽度',
      value: '',
      rules: [
        { required: true, message: '请输入素材宽度', trigger: ['blur', 'change'] },
      ],
    },
    // 素材高度
    height: {
      type: 'input',
      props: {
        placeholder: '请输入素材高度',
        type: 'number',
      },
      on: {
        change: (val) => {
          form_params.height.value = Number(val);
        },
      },
      label: '素材高度',
      value: null,
      rules: [
        { required: true, message: '请输入素材高度', trigger: ['blur', 'change'] },
      ],
    },
    // MIME 类型
    mime_type: {
      type: 'select',
      props: {
        placeholder: '请选择MIME类型',
        multiple: true,
      },
      options: [],
      label: 'MIME 类型',
      value: null,
      rules: [
        { required: true, message: '请选择MIME类型', trigger: ['blur', 'change'],
          validator: (rule, value, callback) => {
            if (s.format_form.form_params.mime_type.options.length > 0) {
              if (value.length === 0) {
                callback(new Error('请选择MIME类型'));
              } else {
                callback();
              }
            } else {
              callback();
            }
          },
        },
      ],
    },
    // 视频最短
    min_millisecond: {
      type: 'input',
      props: {
        placeholder: '请输入视频最短时间',
        type: 'number',
      },
      on: {
        change: (val) => {
          form_params.min_millisecond.value = Number(val);
        },
      },
      label: '视频最短',
      value: 0,
      rules: [
        { required: true, message: '请输入视频最短时间', trigger: ['blur', 'change'] },
      ],
      hidden: true,
    },
    // 视频最长
    max_millisecond: {
      type: 'input',
      props: {
        placeholder: '请输入视频最长时间',
        type: 'number',
      },
      on: {
        change: (val) => {
          form_params.max_millisecond.value = Number(val);
        },
      },
      label: '视频最长',
      value: 0,
      rules: [
        { required: true, message: '请输入视频最长时间', trigger: ['blur', 'change'] },
      ],
      hidden: true,
    },
  };

  return form_params;
};
